import Vue from 'vue'
import { IonicVueRouter } from '@ionic/vue';

import PrivacyPolicy from './views/PrivacyPolicy.vue';
import TermsConditions from './views/TermsConditions.vue';

import SplashScreen from './views/SplashScreen.vue';
import HomePage from './views/HomePage.vue';

import UserLogin from './views/UserLogin.vue';
import UserLogout from './views/UserLogout.vue';

import FormList from './views/FormList.vue';
import FormDetails from './views/FormDetails.vue';
import FormEdit from './views/FormEdit.vue';
import FormShare from './views/FormShare.vue';

import EntryDetails from './views/EntryDetails.vue';
import EntryEdit from './views/EntryEdit.vue';

Vue.use(IonicVueRouter);

const router = new IonicVueRouter({
  base: '/',
  mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  routes: [
    {
      path: '*',
      redirect: "loading"
    },
    {
      path: '/',
      redirect: "loading"
    },
    {
      path: '/loading',
      name: 'splash-screen',
      component: SplashScreen,
      meta: {
        title: 'FormSheets',
        requiresAuth: false
      },
    }, 
    {
      path: '/privacy',
      name: 'privacy-policy',
      component: PrivacyPolicy,
      meta: {
        title: 'FormSheets',
        requiresAuth: false
      },
    }, 
    {
      path: '/terms',
      name: 'terms-conditions',
      component: TermsConditions,
      meta: {
        title: 'FormSheets',
        requiresAuth: false
      },
    },
    {
      path: '/home',
      name: 'home-page',
      component: HomePage,
      meta: {
        title: 'FormSheets',
        requiresAuth: false
      },
    }, 
    {
      path: '/login',
      name: 'user-login',
      component: UserLogin,
      meta: {
        title: 'FormSheets',
        requiresAuth: false
      },
    }, 
    {
      path: '/logout',
      name: 'user-logout',
      component: UserLogout,
      meta: {
        title: 'FormSheets',
        requiresAuth: false
      },
    }, 
    {
      path: '/forms/edit',
      name: 'form-edit',
      component: FormEdit,
      meta: {
        title: 'FormSheets | Form Edit',
        requiresAuth: true
      }
    }, 
    {
      path: '/forms/:id',
      name: 'form-details',
      component: FormDetails,
      props: true,
      meta: {
        title: 'FormSheets | Form Details',
        requiresAuth: true
      }
    }, 
    {
      path: '/forms/:id/share',
      name: 'form-share',
      component: FormShare,
      props: true,
      meta: {
        title: 'FormSheets | Form Details',
        requiresAuth: true
      }
    }, 
    {
      path: '/entries/edit',
      name: 'entry-edit',
      component: EntryEdit,
      props: true,
      meta: {
        title: 'FormSheets | Entry Edit',
        requiresAuth: true
      },
    },
    {
      path: '/forms/:form_id/entries/:id',
      name: 'entry-details',
      component: EntryDetails,
      props: true,
      meta: {
        title: 'FormSheets | Entry Details',
        requiresAuth: true
      },
    },
    {
      path: "/forms",
      name: 'form-list',
      component: FormList,
      meta: {
        title: 'FormSheets | Forms',
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  if (!nearestWithMeta) {
    return next();
  }
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');
    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });
    tag.setAttribute('data-vue-router-controlled', '');
    return tag;
  }).forEach(tag => document.head.appendChild(tag));
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next('login');
  }
  else if (!requiresAuth && currentUser) {
    next('forms');
  }
  else {
    next();
  }
});

export default router;